import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";
import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "WorkflowsModalCreate",
  components: {
    Modal,
    PuxButton,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    selectorClose: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      model: {
        wf_start: false,
      },
      options: {
        showCloseButton: true,
        required: true,
        list: [
          {
            id: "wf_kbez",
            type: "text",
            label: this.$gettext("Name"),
            required: true,
            maxlength: 200,
            view: "v",
          },
          {
            id: "wf_bez",
            type: "richtext",
            label: this.$gettext("Beschreibung"),
            view: "v-alt",
          },
          {
            id: "workflowtyp",
            type: "select",
            label: this.$gettext("Workflowtyp"),
            required: true,
            keyLabel: "bez",
            keyId: "id",
            search: true,
            searchList: ["bez"],
            view: "v",
            url: "katalog/?fields=id&fields=bez&key=workflowtyp",
          },
          {
            id: "start_aufgabe",
            type: "select",
            label: this.$gettext("Startaufgabe"),
            required: true,
            keyLabel: "bez",
            keyId: "id",
            search: true,
            searchList: ["bez"],
            view: "v",
            url: "katalog/?fields=id&fields=bez&key=kaufgabe",
          }
        ],
      },
      status: {
        loading: undefined,
      },
      errors: undefined,
      errorsClone: undefined,
    };
  },
  methods: {
    onChange() { },

    onError({ error }) {
      this.errors = error;
      this.errorsClone = error;
    },

    save() {
      this.status.loading = true;
      const data = cloneDeep(this.model);

      this.postHttp({ url: "workflows/", data }).then(
        response => {
          this.addNotification({ text: "_MSG_WF_MODAL_CREATE_SUCCESS_" });
          this.close();
          this.$goTo("root.workflows.details", { id: response.pk });
        },
        error => {
          this.onError({ error: error.data });
        }
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
